import { useState, useEffect } from 'react';
import { hyphenateRu } from '@/utils/hyphenateRu';

/** Возвращает текст с мягкими переносами. Работает с uppercase. */
export function useHyphenateRu(text: string | null | undefined): string {
  const [hyphenated, setHyphenated] = useState(text ?? '');

  useEffect(() => {
    const raw = text?.trim();
    if (!raw) {
      setHyphenated(text ?? '');
      return;
    }
    setHyphenated(text ?? '');
    let cancelled = false;
    hyphenateRu(raw).then((result) => {
      if (!cancelled) setHyphenated(result);
    });
    return () => {
      cancelled = true;
    };
  }, [text]);

  return text != null && !text.trim() ? text : hyphenated;
}
